import { request } from '@/shared/api/request'

export const getPdfResult = (payload, lang) => {
	return request({ responseType: 'blob', url: `selftest/pdf/${lang}?data=` + payload, method: 'GET' })
}
